frontApp.burger = {
  name: 'burger',
  description: 'Catalog menu and mobile menu in the header',
  menu: '.js-burger-menu',
  list: '.js-burger-list',
  drop: '.js-burger-list-drop',
  back: '.js-burger-list-back',
  control: '.js-burger-control',
  close: '.js-burger-close',
  overlay: '.js-burger-overlay',
  isOpen: false,
  init() {
    const lis = document.querySelectorAll(`${this.menu} li`);
    lis.forEach((li) => {
      if (frontApp.utilities.children(li, this.drop).length) {
        const arrow = document.createElement('em');
        li.prepend(arrow);
      }
    });

    this.events();
  },
  events() {
    const menu = document.querySelector(this.menu);
    if (!menu) {
      return false;
    }

    const self = this;

    const links = document.querySelectorAll(`${this.menu} li > a, ${this.menu} li > em`);

    function addHover() {
      return function (evt) {
        if (evt.type === 'mouseenter' && window.innerWidth < 992) {
          return false;
        }

        const curLink = this;
        const curLi = curLink.parentNode;

        curLi.classList.add('hover');

        frontApp.utilities.siblings(curLi).forEach((sibling) => {
          sibling.classList.remove('hover');
        });

        if (frontApp.utilities.children(curLi, self.drop).length) {
          // Добавляем класс '.drop-is-open' на элемент меню
          // только, если у текущего пункта есть подменю.
          menu.classList.add('drop-is-open');
        } else if (!curLink.closest(self.drop)) {
          menu.classList.remove('drop-is-open');
        }
      };
    }

    links.forEach((link) => {
      link.addEventListener('mouseenter', addHover());
      link.addEventListener('click', addHover());

      link.addEventListener('mouseleave', function () {
        const curLi = this.parentNode;
        if (!frontApp.utilities.children(curLi, self.drop).length) {
          // Удалять класс '.hover' с пункта меню
          // только, если у текущего пункта нет подменю,
          // чтобы подменю всегда оставались открытыми.
          curLi.classList.remove('hover');
        }
      });
    });

    const control = document.querySelector(this.control);
    control.addEventListener('click', (e) => {
      e.preventDefault();
      if (self.isOpen) {
        self.closeMenu();
      } else {
        self.openMenu();
      }
    });

    const backs = document.querySelectorAll(this.back);
    backs.forEach((back) => {
      back.addEventListener('click', () => {
        const lis = document.querySelectorAll(`${this.menu} li`);
        lis.forEach((li) => li.classList.remove('hover'));
        menu.classList.remove('drop-is-open');
      });
    });

    const close = document.querySelector(this.close);
    close.addEventListener('click', () => {
      self.closeMenu();
    });

    document.addEventListener('click', (e) => {
      if (
        !e.target.closest(self.menu)
        && !e.target.closest(self.control)
        && !e.target.closest('.js-search-panel') // search.js
        && !e.target.closest('.js-search-control') // search.js
        && !e.target.closest('.js-clear-scroll-locks-prevent') // other elements
      ) {
        self.closeMenu();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && self.isOpen) {
        self.closeMenu();
      }
    });
  },
  closeMenu() {
    this.isOpen = false;
    const els = document.querySelectorAll(`${this.menu}, ${this.control}, ${this.close}, ${this.overlay}`);
    els.forEach((el) => {
      el.classList.remove('is-open');
    });
    document.querySelectorAll(`${this.menu} li`).forEach((li) => {
      li.classList.remove('hover');
    });
    document.querySelectorAll(this.menu).forEach((li) => {
      li.classList.remove('drop-is-open');
    });
    // Disabled lock body scroll
    document.body.style.marginRight = '';
    bodyScrollLock.clearAllBodyScrollLocks();
  },
  openMenu() {
    this.isOpen = true;
    // Add active classes
    const els = document.querySelectorAll(`${this.menu}, ${this.control}, ${this.close}, ${this.overlay}`);
    els.forEach((el) => {
      el.classList.add('is-open');
    });
    // Lock body scroll
    document.body.style.marginRight = `${(window.innerWidth - document.documentElement.clientWidth)}px`;
    const scrollContainers = document.querySelectorAll(`.burger-menu__main, ${this.drop}`);
    scrollContainers.forEach((el) => {
      bodyScrollLock.disableBodyScroll(el);
    });
  },
};
